const LoadingSnipQuiz = () => {
    return (
        <div 
            className="d-flex justify-content-center align-items-center" 
            style={{ 
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                zIndex: 9998,
            }}
        >
            <div className="spinner-border" role="status" style={{ color: '#792110' }}>
                <span className="visually-hidden">Loading...</span> 
            </div>
        </div>
    )
}

export default LoadingSnipQuiz